$(document).on('change', '.dnJs-OrganiserData-select-trigger', function(e) {
    var selected = $("option:selected", this).text();
    var url      = $(this).data('url');

    $.ajax({
        type: "POST",
        url: url,
        data: {string: selected },
        success: function(obj)
        {
            if (typeof obj === 'object' )
            {
                $('#ticket_general_company').val(obj.company);
                $('#ticket_general_street').val(obj.street);
                $('#ticket_general_zip_code').val(obj.zip_code);
                $('#ticket_general_city').val(obj.city);
                $('#ticket_general_vat_no').val(obj.vat_no);
                $('#ticket_general_contact_email').val(obj.contact_email);
                $('#ticket_general_iban').val(obj.iban);
                $('#ticket_general_bic').val(obj.bic);
                $('#ticket_general_contact_phone').val(obj.contact_phone);
                $('#ticket_general_contact_name').val(obj.contact_name);

                $('#ticket_general_public_email').val(obj.public_email);
                $('#ticket_general_public_phone').val(obj.public_phone);                $('#ticket_general_contact_phone').val(obj.contact_phone);
                $('#ticket_general_public_website_url').val(obj.public_website_url);
                $('#ticket_general_public_imprint_url').val(obj.public_imprint_url);
                $('#ticket_general_public_agb_url').val(obj.public_agb_url);

                if ($('#ticket-general-organizer-data-container').length) {
                    $('#ticket-general-organizer-data-container').removeClass('hidden');
                }
            } else {
                $('#ticket_general_company').val('');
                $('#ticket_general_street').val('');
                $('#ticket_general_zip_code').val('');
                $('#ticket_general_city').val('');
                $('#ticket_general_vat_no').val('');
                $('#ticket_general_contact_email').val('');
                $('#ticket_general_iban').val('');
                $('#ticket_general_bic').val('');
                $('#ticket_general_contact_phone').val('');
                $('#ticket_general_contact_name').val('');
            }
        }
    });

});

$(document).on('click', '.dnJs-OrganiserData-new', function(e) {
    if ($('#ticket-general-organizer-data-container').length) {
        $('#ticket-general-organizer-data-container').removeClass('hidden');
    }

    $('#ticket_general_company').val('');
    $('#ticket_general_street').val('');
    $('#ticket_general_zip_code').val('');
    $('#ticket_general_city').val('');
    $('#ticket_general_vat_no').val('');
    $('#ticket_general_contact_email').val('');
    $('#ticket_general_iban').val('');
    $('#ticket_general_bic').val('');
    $('#ticket_general_contact_phone').val('');
    $('#ticket_general_contact_name').val('');
});